// Fragment « divers » (NL) : Over ons, Contact, klantbeoordelingen, cookiebanner.
// Mêmes clés que fr/divers.js, valeurs en néerlandais.
export default {
  // ---- Over ons (pages/About.jsx) ----
  'apropos.seo.titre': 'Over ons',
  'apropos.seo.description': 'Ontdek het verhaal van Mirum Games en onze passie om magische familiemomenten te creëren met Joyful Reveal, de puzzels uit hoogwaardige materialen.',
  'apropos.hero.badge': '🎮 Ons verhaal',
  'apropos.hero.titre': 'Welkom bij Mirum Games',
  'apropos.hero.texte': 'Wij creëren magische momenten om de komst van uw baby te vieren en die vreugde met het hele gezin te delen.',
  'apropos.mission.titre': 'Onze missie',
  'apropos.mission.texte1': 'Bij Mirum Games geloven we dat de belangrijke momenten in het leven het verdienen om op een unieke en gedenkwaardige manier gevierd te worden. Onze missie is feestelijke en interactieve ervaringen te creëren die van de gender reveal van de baby een onvergetelijk moment van samenzijn met het gezin maken.',
  'apropos.mission.texte2': 'Elke puzzel is met zorg ontworpen om een moment vol spanning en vreugde te creëren, met een uitzonderlijke kwaliteit en een ervaring die het hele gezin bijblijft.',
  'apropos.mission.encart.titre': 'Spelenderwijs vieren',
  'apropos.mission.encart.texte': 'Van de onthulling een leuk vraag-en-antwoordspel maken waar iedereen aan meedoet',
  'apropos.mission.carte1.titre': 'Spanning',
  'apropos.mission.carte1.texte': 'Een gedenkwaardig moment van spanning en verwachting creëren',
  'apropos.mission.carte2.titre': 'Feest',
  'apropos.mission.carte2.texte': 'Van de onthulling een feestelijk en gedenkwaardig moment maken',
  'apropos.mission.carte3.titre': 'Samen delen',
  'apropos.mission.carte3.texte': 'Kwaliteitstijd met het gezin',
  'apropos.valeurs.titre': 'Onze kernwaarden',
  'apropos.valeurs.soustitre': 'De principes die elk van onze beslissingen sturen',
  'apropos.valeurs.excellence.titre': 'Uitmuntendheid',
  'apropos.valeurs.excellence.texte': 'We sluiten nooit compromissen over kwaliteit. Elk detail telt, van het ontwerp tot de afwerking van de puzzel.',
  'apropos.valeurs.creativite.titre': 'Creativiteit',
  'apropos.valeurs.creativite.texte': 'We blijven vernieuwen om unieke en gedenkwaardige onthullingen te bedenken die echt bijblijven.',
  'apropos.valeurs.authenticite.titre': 'Authenticiteit',
  'apropos.valeurs.authenticite.texte': 'We blijven trouw aan onze waarden en aan ons engagement tegenover onze klanten en onze community.',
  'apropos.valeurs.innovation.titre': 'Innovatie',
  'apropos.valeurs.innovation.texte': 'We zoeken voortdurend naar nieuwe manieren om uitzonderlijke feestmomenten te creëren.',
  'apropos.valeurs.emotions.titre': 'Emoties',
  'apropos.valeurs.emotions.texte': 'We creëren momenten vol emotie die het hele gezin zich blijft herinneren.',
  'apropos.valeurs.passion.titre': 'Passie',
  'apropos.valeurs.passion.texte': 'We zijn gepassioneerd door wat we doen, en dat voelt u in elk product.',
  'apropos.reseaux.titre': 'Onze sociale media',
  'apropos.reseaux.soustitre': 'Word lid van onze community en kijk mee achter de schermen',
  'apropos.reseaux.instagram.texte': 'Ontdek onze nieuwste creaties, kijk achter de schermen bij onze puzzels en deel uw magische momenten met #MirumGames',
  'apropos.reseaux.facebook.texte': 'Word lid van onze community, doe mee aan wedstrijden en blijf op de hoogte van onze exclusieve aanbiedingen en nieuwigheden',
  'apropos.processus.titre': 'Ons creatieproces',
  'apropos.processus.soustitre': 'Van idee tot bij u thuis',
  'apropos.processus.etape1.titre': 'Onderzoek & ideeën',
  'apropos.processus.etape1.texte': 'We luisteren naar aanstaande ouders en naar iedereen die een gender reveal organiseert, om ervaringen te maken die nog beter bijblijven.',
  'apropos.processus.etape2.titre': 'Ontwerp & tests',
  'apropos.processus.etape2.texte': 'Ons team ontwerpt elke puzzel en test alles grondig, zodat het spel leuk blijft en het moment bijblijft.',
  'apropos.processus.etape3.titre': 'Productie',
  'apropos.processus.etape3.texte': 'Elke puzzel wordt met zorg en oog voor detail gemaakt, voor een premium kwaliteit.',
  'apropos.processus.etape4.titre': 'Kwaliteit & verzending',
  'apropos.processus.etape4.texte': 'Elk spel doorloopt een strenge kwaliteitscontrole voordat het zorgvuldig naar u wordt verzonden.',
  'apropos.cta.titre': 'Klaar om onze spellen te ontdekken?',
  'apropos.cta.texte': 'Ontdek onze volledige collectie en maak van de gender reveal van uw baby een magisch en onvergetelijk moment.',
  'apropos.cta.boutique': '🛍️ Ontdek de shop',
  'apropos.cta.contact': '💬 Neem contact op',

  // ---- Contact (pages/Contact.jsx) ----
  'contact.seo.titre': 'Contact',
  'contact.seo.description': 'Neem contact op met Mirum Games met al je vragen over Joyful Reveal, ons spel, of over je bestellingen. Snel antwoord gegarandeerd.',
  'contact.hero.badge': '💬 Blijf in contact',
  'contact.hero.titre': 'We horen graag van u',
  'contact.hero.texte': 'Vragen? Suggesties? Neem gerust contact met ons op. We antwoorden meestal binnen 24 uur.',
  'contact.cartes.email.titre': 'E-mail',
  'contact.cartes.email.texte': 'Antwoord binnen 24-48 uur',
  'contact.cartes.adresse.titre': 'Adres',
  'contact.cartes.adresse.ligne1': 'Rue de la Cortaille, 59',
  'contact.cartes.adresse.ligne2': '6800 Freux, België',
  'contact.cartes.faq.titre': 'Vragen?',
  'contact.cartes.faq.texte': 'Bekijk onze FAQ',
  'contact.cartes.faq.soustexte': 'Meteen een antwoord',
  'contact.formulaire.titre': 'Stuur ons een bericht',
  'contact.formulaire.nom': 'Uw naam',
  'contact.formulaire.nomPlaceholder': 'Jan Janssens',
  'contact.formulaire.email': 'E-mail',
  'contact.formulaire.emailPlaceholder': 'uw@email.com',
  'contact.formulaire.sujet': 'Onderwerp',
  'contact.formulaire.sujetPlaceholder': '-- Kies een onderwerp --',
  'contact.formulaire.sujetCommande': 'Vraag over mijn bestelling',
  'contact.formulaire.sujetProduit': 'Vraag over een product',
  'contact.formulaire.sujetLivraison': 'Vraag over de levering',
  'contact.formulaire.sujetPartenariat': 'Samenwerking',
  'contact.formulaire.sujetAutre': 'Andere',
  'contact.formulaire.message': 'Bericht',
  'contact.formulaire.messagePlaceholder': 'Uw bericht hier...',
  'contact.formulaire.envoiEnCours': '⏳ Versturen...',
  'contact.formulaire.envoyer': '📬 Bericht versturen',
  'contact.formulaire.succes': '✨ Bedankt voor uw bericht! We antwoorden u heel snel.',
  'contact.faq.titre': 'Veelgestelde vragen',
  'contact.faq.soustitre': 'Misschien staat uw antwoord hier al',
  'contact.faq.q1': '❓ Hoelang duurt de levering?',
  'contact.faq.a1': "Bestellingen vertrekken gemiddeld binnen één werkdag uit België. Reken daarna op 1 tot 2 werkdagen voor Luxemburg, België en Nederland, 2 tot 4 dagen voor Frankrijk en Duitsland, en 4 tot 5 dagen voor Spanje.",
  'contact.faq.q2': '🎁 Kan ik een persoonlijke boodschap toevoegen?',
  'contact.faq.a2': 'Natuurlijk! Onze premium packs bevatten een gepersonaliseerde kaart. Neem na uw bestelling contact met ons op voor de details.',
  'contact.faq.q3': '💰 Is er een garantie?',
  'contact.faq.a3': 'Ja! U hebt 14 dagen om een product terug te sturen dat u niet bevalt. Bovendien geven we op al onze producten garantie tegen verborgen gebreken.',
  'contact.faq.q4': '🌍 Leveren jullie naar het buitenland?',
  'contact.faq.a4': "Wij leveren in België, Frankrijk, Luxemburg, Nederland, Duitsland en Spanje. Bij het afrekenen kiest u tussen levering aan huis en een afhaalpunt, afhankelijk van de vervoerders die op uw adres beschikbaar zijn.",
  'contact.faq.q5': '🎮 Hoe werkt de puzzel?',
  'contact.faq.a5': 'Het is een leuk vraag-en-antwoordspel dat u doorheen de puzzel leidt. Bij elk juist antwoord legt u puzzelstukjes bij, tot u ontdekt of het een jongen of een meisje wordt!',
  'contact.faq.q6': '🎊 Met hoeveel personen kun je spelen?',
  'contact.faq.a6': 'De puzzel is gemaakt om samen met het gezin te spelen! U kunt teams vormen en met meerderen spelen om het moment nog feestelijker te maken.',
  'contact.newsletter.titre': 'Blijf op de hoogte',
  'contact.newsletter.texte': 'Schrijf u in op onze nieuwsbrief en ontvang onze laatste aanbiedingen en nieuwtjes',
  'contact.newsletter.emailPlaceholder': 'uw@email.com',
  'contact.newsletter.inscrire': 'Inschrijven',
  'contact.newsletter.succes': '✨ Welkom bij onze nieuwsbrief!',

  // ---- Klantbeoordelingen (components/Reviews/*) ----
  // De INHOUD van de beoordelingen (tekst, titel, naam van de auteur) komt uit
  // de database en wordt nooit vertaald ; alleen het kader gebruikt deze sleutels.
  'avis.section.badge': '💬 Ervaringen van klanten',
  'avis.section.titre': 'Wat onze klanten geweldig vinden',
  'avis.section.accrocheAucun': 'Al gespeeld? Vertel ons over uw moment — uw beoordeling helpt de volgende aanstaande ouders bij hun keuze.',
  'avis.section.accrochePeu': 'Zij speelden het vóór u en namen de tijd om ons te schrijven. Dit zijn hun woorden, ongefilterd.',
  'avis.section.accrocheNombreux': 'Al {n} gezinnen deelden hun moment met ons.',
  'avis.section.compteurSingulier': 'beoordeling',
  'avis.section.compteurPluriel': 'beoordelingen',
  'avis.section.premierAvis': 'Geef als eerste uw beoordeling!',
  'avis.section.fermer': '✕ Sluiten',
  'avis.section.laisserAvis': '✍️ Beoordeling schrijven',
  'avis.section.chargement': 'Beoordelingen laden...',
  'avis.section.listeTitre': 'De beoordelingen',
  'avis.section.aucunTitre': 'Wees de eerste!',
  'avis.section.aucunTexte': 'Nog geen beoordelingen. Deel als eerste uw magische ervaring!',
  'avis.section.ecrirePremier': 'Schrijf de eerste beoordeling',
  'avis.section.erreurEnvoi': 'Er ging iets mis bij het versturen van de beoordeling',
  'avis.carte.noteAria': 'Score van {note} op 5',
  'avis.carte.clientVerifie': 'Geverifieerde klant',
  'avis.carte.achatVerifie': '✅ Geverifieerde aankoop',
  'avis.formulaire.titre': 'Deel uw ervaring',
  'avis.formulaire.note': 'Algemene score',
  'avis.formulaire.noterAria': '{n} sterren geven',
  'avis.formulaire.note5': 'Uitstekend! 🤩',
  'avis.formulaire.note4': 'Heel goed 🙂',
  'avis.formulaire.note3': 'Goed 😐',
  'avis.formulaire.note2': 'Matig 😕',
  'avis.formulaire.note1': 'Teleurgesteld 😞',
  'avis.formulaire.titreAvis': 'Titel van uw beoordeling',
  'avis.formulaire.titrePlaceholder': 'Bv.: Toffe puzzel, mijn dochter is er dol op!',
  'avis.formulaire.commentaire': 'Uw commentaar',
  'avis.formulaire.commentairePlaceholder': 'Vertel ons wat u leuk vond...',
  'avis.formulaire.envoiEnCours': 'Bezig met versturen...',
  'avis.formulaire.publier': 'Mijn beoordeling plaatsen',

  // ---- Cookiebanner (components/CookieConsent.jsx) ----
  'cookies.bandeau.titre': '🍪 Cookiebeheer',
  'cookies.bandeau.texte': "Deze site gebruikt maar twee dingen: de cookies die uw winkelmandje en uw login nodig hebben, en een anonieme bezoekersmeting die wij zelf doen, zonder cookie en zonder u ooit te identificeren. Geen reclame, geen profilering, niets gedeeld met derden.",
  'cookies.gerer': "Mijn cookies beheren",
  'cookies.categories.necessaires': 'Noodzakelijke cookies',
  'cookies.categories.necessairesDesc': 'Altijd actief - Essentieel voor de werking van de site',
  'cookies.categories.analytics': "Anonieme bezoekersmeting",
  'cookies.categories.analyticsDesc': "Aantal bezoeken en bekeken pagina's. Zonder cookie, zonder identificatie, uw IP-adres wordt nooit bewaard. U mag dit weigeren.",
  'cookies.categories.marketing': 'Marketingcookies',
  'cookies.categories.marketingDesc': 'Om u gepersonaliseerde inhoud en aanbiedingen te tonen',
  'cookies.bandeau.voirNotre': 'Bekijk ons',
  'cookies.bandeau.politique': 'Privacybeleid',
  'cookies.bandeau.plusInfos': 'voor meer informatie',
  'cookies.actions.refuser': 'Alles weigeren',
  'cookies.actions.personnaliser': 'Aanpassen',
  'cookies.actions.accepter': 'Alles aanvaarden',

  // --- Connexion, inscription, profil ---
  // Ces trois pages n'etaient pas traduites du tout : un visiteur allemand
  // cliquait « Anmelden » dans une barre de navigation allemande et recevait
  // un formulaire entierement francais.
  'compte.connexion.seoTitre': "Inloggen",
  'compte.connexion.seoDescription': "Log in op uw Mirum Games-account.",
  'compte.connexion.titre': "Inloggen",
  'compte.connexion.sousTitre': "Welkom bij Mirum Games",
  'compte.champ.email': "E-mailadres",
  'compte.champ.emailPlaceholder': "uw@email.com",
  'compte.champ.motDePasse': "Wachtwoord",
  'compte.champ.motDePassePlaceholder': "Uw wachtwoord",
  'compte.champ.basculerMotDePasse': "Wachtwoord tonen of verbergen",
  'compte.connexion.seSouvenir': "Onthoud mij",
  'compte.connexion.motDePasseOublie': "🔑 Wachtwoord vergeten?",
  'compte.connexion.bouton': "🔓 Inloggen",
  'compte.connexion.enCours': "⏳ Bezig met inloggen…",
  'compte.connexion.ouContinuerAvec': "Of ga verder met",
  'compte.connexion.pasDeCompte': "Nog geen account?",
  'compte.connexion.creerUnCompte': "Account aanmaken",
  'compte.connexion.erreur': "Ongeldige gegevens. Probeer het opnieuw.",
  'compte.connexion.erreurGoogle': "Er ging iets mis bij het inloggen met Google.",
  'compte.inscription.seoTitre': "Registreren",
  'compte.inscription.seoDescription': "Maak uw Mirum Games-account aan.",
  'compte.inscription.titre': "Registreren",
  'compte.inscription.sousTitre': "Word lid van de Mirum Games-gemeenschap",
  'compte.champ.nomComplet': "Volledige naam",
  'compte.champ.nomCompletPlaceholder': "Jan Janssens",
  'compte.champ.creerMotDePasse': "Kies een veilig wachtwoord",
  'compte.champ.confirmation': "Wachtwoord bevestigen",
  'compte.champ.confirmationPlaceholder': "Bevestig uw wachtwoord",
  'compte.force.faible': "❌ Zwak",
  'compte.force.moyen': "⚠️ Gemiddeld",
  'compte.force.fort': "✅ Sterk",
  'compte.inscription.accepteLes': "Ik aanvaard de",
  'compte.inscription.conditions': "algemene verkoopvoorwaarden",
  'compte.inscription.etLa': "en het",
  'compte.inscription.politique': "privacybeleid",
  'compte.inscription.bouton': "🎮 Account aanmaken",
  'compte.inscription.enCours': "⏳ Account wordt aangemaakt…",
  'compte.inscription.dejaUnCompte': "Hebt u al een account?",
  'compte.inscription.seConnecter': "Inloggen",
  'compte.inscription.erreurMotsDePasse': "De wachtwoorden komen niet overeen.",
  'compte.inscription.erreurConditions': "Gelieve de algemene voorwaarden te aanvaarden.",
  'compte.inscription.erreurLongueur': "Het wachtwoord moet minstens 6 tekens bevatten.",
  'compte.inscription.erreur': "Er ging iets mis bij het registreren. Probeer het opnieuw.",
  'compte.profil.deconnexion': "Uitloggen",
  'compte.profil.mesCommandes': "📦 Mijn bestellingen",
  'compte.profil.informations': "👤 Gegevens",
  'compte.profil.informationsTitre': "Persoonlijke gegevens",
  'compte.commandes.chargement': "Bestellingen worden geladen…",
  'compte.commandes.aucune': "U hebt nog geen bestelling geplaatst.",
  'compte.commandes.decouvrir': "Ontdek onze producten",
  'compte.commandes.articles': "Artikelen:",
  'compte.commandes.total': "Totaal:",
  'compte.commandes.suiviLabel': "Trackingnr.:",
  'compte.commandes.suivre': "Mijn pakket volgen",
  'compte.commandes.facture': "Factuur downloaden",
  "compte.commandes.noteCredit": "Creditnota",
  'compte.commandes.avis': "Beoordeling schrijven",
  'compte.commandes.nonAuthentifie': "Uw sessie is verlopen. Log opnieuw in.",
  'compte.commandes.erreur': "Er ging iets mis bij het laden van uw bestellingen",
  'compte.statut.paid': "Betaald",
  'compte.statut.shipped': "Verzonden",
  'compte.statut.delivered': "Geleverd",
  'compte.statut.cancelled': "Geannuleerd",
  'compte.infos.general': "Algemene gegevens",
  'compte.infos.nomComplet': "Volledige naam *",
  'compte.infos.emailFige': "Het e-mailadres kan niet worden gewijzigd",
  'compte.infos.adresseLivraison': "Leveringsadres",
  'compte.infos.adresse': "Adres",
  'compte.infos.adressePlaceholder': "Straat en huisnummer",
  'compte.infos.ville': "Plaats",
  'compte.infos.codePostal': "Postcode",
  'compte.infos.pays': "Land",
  'compte.infos.choisirPays': "Kies een land",
  'compte.infos.telephone': "Telefoon",
  'compte.infos.enregistrer': "💾 Opslaan",
  'compte.infos.enregistrement': "⏳ Bezig met opslaan…",
  'compte.infos.succes': "✅ Uw profiel is bijgewerkt.",
  'compte.infos.erreur': "❌ Er ging iets mis bij het bijwerken van uw profiel",
  "maFacture.seoTitre": "Mijn factuur terugvinden - Mirum Games",
  "maFacture.seoDescription": "Vind de factuur van uw Mirum Games-bestelling terug met uw bestelnummer en e-mailadres.",
  "maFacture.titre": "Mijn factuur terugvinden",
  "maFacture.intro": "Besteld zonder account en vindt u de bevestigingsmail niet meer terug? Vul uw bestelnummer in en het e-mailadres dat u bij de aankoop gebruikte.",
  "maFacture.champNumero": "Bestel- of factuurnummer",
  "maFacture.champNumeroAide": "U vindt het in de bevestigingsmail en op de pagina die na de betaling verscheen.",
  "maFacture.champEmail": "E-mailadres gebruikt bij de aankoop",
  "maFacture.bouton": "Mijn factuur terugvinden",
  "maFacture.recherche": "Zoeken…",
  "maFacture.introuvable": "We vinden geen bestelling met deze gegevens. Controleer het nummer en het e-mailadres dat u bij de aankoop gebruikte.",
  "maFacture.tropDEssais": "Te veel pogingen na elkaar. Wacht een minuut en probeer het dan opnieuw.",
  "maFacture.erreur": "Het zoeken is niet gelukt. Probeer het zo dadelijk opnieuw of schrijf ons.",
  "maFacture.facture": "Uw factuur nr. {numero} staat klaar.",
  "maFacture.voirFacture": "🧾 Factuur bekijken en afdrukken",
  "maFacture.langueDocument": "De factuur is in het Frans opgesteld. U kunt ze vanuit uw browser afdrukken of als pdf opslaan.",
  "maFacture.factureStripe": "🧾 Factuur van deze bestelling bekijken",
  "maFacture.enAttente": "Uw betaling is nog niet binnen: we mailen u de factuur zodra ze ontvangen is.",
  "maFacture.aucune": "Voor deze bestelling is er geen online factuur. Schrijf ons, dan sturen we ze u.",
  "maFacture.voirNote": "Creditnota nr. {numero}",
  "maFacture.compte": "Hebt u een account? Al uw facturen staan in",
};
